  $(document).ready(function () {
    $('.text-sliderr').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.image-sliderr',
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 600
    });

    $('.image-sliderr').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.text-sliderr',
      dots: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      prevArrow:
      "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0702/2136/5414/files/Button_-_Next.svg?v=1754908393'>",
     nextArrow:
      "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0702/2136/5414/files/Button_-_Next_1.svg?v=1754908393'>",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });
  });